import React, { Component, ComponentType } from 'react';
import { wrapDisplayName } from 'recompose';

import { WlWindow } from '../../typings/globals/cordova';

declare const window: WlWindow;

export type platforms = 'pizza' | 'cordova' | 'server' | 'app';
const platformName = PLATFORM as platforms;

const IncludeOnPlatforms = function (includedPlatforms: platforms[]) {
  return function <P>(WrappedComponent: ComponentType<P>): ComponentType<P> {
    return class IncludeOnPlatformsInternal extends Component<P> {
      static displayName = wrapDisplayName(
        WrappedComponent,
        'IncludeOnPlatforms',
      );

      render() {
        const isServer =
          window.isPreRender && includedPlatforms.includes('server');
        if (isServer || includedPlatforms.includes(platformName)) {
          return <WrappedComponent {...this.props} />;
        }
        return null;
      }
    };
  };
};

export default IncludeOnPlatforms;
